module.exports = __webpack_public_path__ + "static/media/apple.301652c6.svg";